export class PickingListTranshipmentParams {
    page = 1;
    limit = 10;
    code?: string;
    status?: number;
    fromDate?: number;
    toDate?: number;
    partnerRowGuid?: string;
    postOfficeFromRowGuid?: string;
    postOfficeToRowGuid?: string;
    acceptancePostOfficeRowGuid?: string;
}